import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TabContent.css';
import AlertPopup from './AlertPopup';

const AppointmentsTab = ({ userDetails }) => {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState({});
    const [alert, setAlert] = useState({ message: '', type: 'info' });

    //a function for payment
    const handlePayment = async (appointment)=>{
        await axios.get(`${process.env.REACT_APP_API_BASE_URL}/specificAppointment?aid=${appointment.id}`)
                .then(async res=>{
                    console.log(res.data[0]);
                     //start payment
                    const paymentData = {
                        appointmentId: appointment.id,
                        healer_name: res.data[0].firstname + ' ' + res.data[0].lastname,
                        healer_email: res.data[0].email,
                        amount: res.data[0].price, //total price + 12% fee for woowoonet
                        currency: "cad",
                        items: [
                            {
                                service_name: res.data[0].service_id,
                                quantity: 1,
                                price: res.data[0].price,
                            }
                        ]
                    };
                        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payment`, paymentData)
                        .then(async response => {
                            console.log('Proceed to payment');
                            //storing the payment intent for appointment table. Does not mean that it is paid.
                            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointment.id}`, {
                                payment_intent: response.data.payment_intent
                            }).then(appointmentRes=>{
                                console.log(`Payment intent updated for appointment ${appointment.id}`);
                                window.location.assign(response.data.url);
                            })
                            .catch(err=>{
                                console.log(`Error updating payment intent for appointment ${appointment.id}`);
                            })
                            
                        })
                        .catch(error => {
                            // console.error("There was an error making the appointment payment!", error);
                            // actions.setSubmitting(false);
                            // setErrorMessage('There was an error making the appointment payment.');
                            // //window.location.assign('/search');
                            console.log("There was an error in paying for appointment");
                        });
                })
                .catch(err=>{
                    console.log(err);
                })
    }
    const handleAppointmentAction = async (appointmentId, action) => {
        setUpdating(prev => ({ ...prev, [appointmentId]: true }));
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/appointments/${appointmentId}`, {
                confirmed: action === 'accept' ? true : false
            });

            // Update the local state
            setAppointments(prev => prev.map(apt =>
                apt.id === appointmentId
                    ? { ...apt, confirmed: action === 'accept' ? true : false }
                    : apt
            ));

            // Show success message
            const actionText = action === 'accept' ? 'accepted' : 'rejected';
            setAlert({
                message: `Appointment ${actionText} successfully!`,
                type: 'success'
            });

        //     //if accept the appointment, send a message to the client
        //     if(action === 'accept' && userDetails.role === 'healer'){
        //         //getting broad info from this specific appoint id
        //         await axios.get(`${process.env.REACT_APP_API_BASE_URL}/specificAppointment?aid=${appointmentId}`)
        //         .then(async res=>{
        //             console.log(res.data[0]);
        //              //start payment
        //             const paymentData = {
        //                 healer_name: res.data[0].firstname + ' ' + res.data[0].lastname,
        //                 healer_email: res.data[0].email,
        //                 amount: res.data[0].price,
        //                 currency: "cad",
        //                 items: [
        //                     {
        //                         service_name: res.data[0].service_id,
        //                         quantity: 1,
        //                         price: res.data[0].price,
        //                     }
        //                 ]
        //             };
        //                 await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payment`, paymentData)
        //                 .then(async response => {
        //                     const messageBody = {
        //                         sender_id: res.data[0].healer_id,
        //                         receiver_id: res.data[0].client_id,
        //                         subject: 'Your appointment status',
        //                         content: 'Your appointment has been accepted. Please follow the link below for payment: ',
        //                         url: response.data.url
        //                     }
        //                     await axios.post(`${process.env.REACT_APP_API_BASE_URL}/message`, messageBody)
        //                     .then(messageRes=>{
        //                         console.log(`Mesage sent`);
        //                     })
        //                     .catch(err=>{
        //                         console.log(`Having error at sending message from healer ${res.data[0].healer_id}`);
        //                     })
        //                 })
        //                 .catch(error => {
        //                     // console.error("There was an error making the appointment payment!", error);
        //                     // actions.setSubmitting(false);
        //                     // setErrorMessage('There was an error making the appointment payment.');
        //                     // //window.location.assign('/search');
        //                     console.log("There was an error in paying for appointment");
        //                 });
        //         })
        //         .catch(err=>{
        //             console.log(err);
        //         })
                
                
        // } 
    }
    catch (error) {
        console.error('Error updating appointment:', error);
        setAlert({
            message: 'Failed to update appointment. Please try again.',
            type: 'error'
        });
    } finally {
        setUpdating(prev => ({ ...prev, [appointmentId]: false }));
    };
    }
    useEffect(() => {
        if (!userDetails?.id) return;

        const fetchAppointments = async () => {
            try {
                let response;
                if (userDetails.role === 'healer') {
                    response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/appointments?healer_id=${userDetails.id}`);
                } else {
                    response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/appointments/clients/${userDetails.id}`);
                }
                setAppointments(response.data);
            } catch (error) {
                console.error('Error fetching appointments:', error);
                setAlert({
                    message: 'Failed to load appointments. Please refresh the page.',
                    type: 'error'
                });
            } finally {
                setLoading(false);
            }
        };

        fetchAppointments();
    }, [userDetails]);

    if (loading) {
        return (
            <div className="tab-content">
                <div className="loaderContainer">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <>
            <AlertPopup
                message={alert.message}
                type={alert.type}
                onClose={() => setAlert({ message: '', type: 'info' })}
            />
            <div className="tab-content">
                <div className="tab-header">
                    <h2>Appointments</h2>
                    <p>View and manage your appointments</p>
                </div>

                <div
                    className="appointments-container grid-appointments-container"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                        gap: '28px',
                        width: '100%',
                        maxWidth: 900,
                        margin: '0 auto',
                        marginTop: 24,
                    }}
                >
                    {appointments.length > 0 ? (
                        appointments.map((appointment, index) => {
                            // Determine status and color
                            let status = 'pending';
                            let statusText = 'Pending';
                            let statusColor = '#ffc107'; // yellow
                            if (appointment.confirmed === true) {
                                status = 'accepted';
                                statusText = 'Accepted';
                                statusColor = '#28a745'; // green
                            } else if (appointment.confirmed === false) {
                                status = 'rejected';
                                statusText = 'Rejected';
                                statusColor = '#dc3545'; // red
                            }
                            return (
                                <div
                                    key={index}
                                    className="appointment-card elevated-appointment-card"
                                    style={{
                                        borderLeft: `6px solid ${statusColor}`,
                                        boxShadow: '0 4px 16px rgba(38,168,153,0.09), 0 1.5px 6px rgba(0,0,0,0.04)',
                                        borderRadius: 16,
                                        marginBottom: 18,
                                        background: '#fff',
                                        padding: '1.7rem 2.2rem',
                                        transition: 'box-shadow 0.2s',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <h4 style={{ margin: 0, color: '#222', fontWeight: 700, fontSize: '1.18rem', letterSpacing: '-0.5px' }}>
                                                {appointment.service?.name || appointment.service_id}
                                            </h4>
                                            <span
                                                className={`status ${status}`}
                                                style={{
                                                    background: statusColor + '22',
                                                    color: statusColor,
                                                    borderRadius: 12,
                                                    fontWeight: 600,
                                                    fontSize: '0.95rem',
                                                    padding: '0.25rem 0.9rem',
                                                    marginLeft: 8
                                                }}
                                            >
                                                {statusText}
                                            </span>
                                        </div>
                                        <span style={{ fontSize: 22, color: '#26a899', marginLeft: 8 }} title="Appointment">
                                            <i className="fa-regular fa-calendar-check"></i>
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'center', marginBottom: 2 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#555', fontSize: '1.01rem' }}>
                                            <i className="fa-regular fa-calendar" style={{ color: '#26a899' }}></i>
                                            <span><strong>Date:</strong> {new Date(appointment.date).toLocaleDateString()}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#555', fontSize: '1.01rem' }}>
                                            <i className="fa-regular fa-clock" style={{ color: '#9c70f3' }}></i>
                                            <span><strong>Time:</strong> {appointment.time}</span>
                                        </div>
                                    </div>
                                    <div style={{ color: '#666', fontSize: '1.01rem', marginTop: 2 }}>
                                        {userDetails.role === 'healer' && (
                                            <span><strong>Client:</strong> {appointment.client ? `${appointment.client.firstname} ${appointment.client.lastname}` : appointment.client_id}</span>
                                        )}
                                        {userDetails.role === 'client' && (
                                            <span><strong>Healer ID:</strong> {appointment.healer_id}</span>
                                        )}
                                    </div>
                                    {/* if the appointment is accepted and the payment is not made*/}
                                    {appointment.confirmed == true && (appointment.paid == false || appointment.paid == null) && appointment.client_id == userDetails.id?
                                    <div style={{
                                            display: 'flex',
                                            gap: 12,
                                            marginTop: 16,
                                            justifyContent: 'flex-end'
                                        }}>
                                            <button
                                                onClick={() => handlePayment(appointment)}
                                                style={{
                                                    background: '#28a745',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: 8,
                                                    padding: '8px 16px',
                                                    fontSize: '0.9rem',
                                                    fontWeight: 600,
                                                    cursor: updating[appointment.id] ? 'not-allowed' : 'pointer',
                                                    opacity: updating[appointment.id] ? 0.6 : 1,
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                Pay Now
                                            </button>
                                    </div>
                                    :
                                    null
                                    }
                                    {/* Action buttons for healers */}
         
                                    {userDetails.role === 'healer' && appointment.confirmed === null && (
                                        <div style={{
                                            display: 'flex',
                                            gap: 12,
                                            marginTop: 16,
                                            justifyContent: 'flex-end'
                                        }}>
                                            <button
                                                onClick={() => handleAppointmentAction(appointment.id, 'accept')}
                                                disabled={updating[appointment.id]}
                                                style={{
                                                    background: '#28a745',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: 8,
                                                    padding: '8px 16px',
                                                    fontSize: '0.9rem',
                                                    fontWeight: 600,
                                                    cursor: updating[appointment.id] ? 'not-allowed' : 'pointer',
                                                    opacity: updating[appointment.id] ? 0.6 : 1,
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                {updating[appointment.id] ? 'Updating...' : 'Accept'}
                                            </button>
                                            <button
                                                onClick={() => handleAppointmentAction(appointment.id, 'reject')}
                                                disabled={updating[appointment.id]}
                                                style={{
                                                    background: '#dc3545',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: 8,
                                                    padding: '8px 16px',
                                                    fontSize: '0.9rem',
                                                    fontWeight: 600,
                                                    cursor: updating[appointment.id] ? 'not-allowed' : 'pointer',
                                                    opacity: updating[appointment.id] ? 0.6 : 1,
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                {updating[appointment.id] ? 'Updating...' : 'Reject'}
                                            </button>
                                        </div>
                                    )}
                                    
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-appointments" style={{ gridColumn: '1/-1' }}>
                            <p>No appointments found.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};


export default AppointmentsTab; 